import axios from 'axios';
import config from '../config';
import { sessionID } from './../../utils/handlingSession'
import { userLogs } from './../logs/userLogs'

export const getBannerConfiguration = async () => {
    let url = config.hummBackendAppURL + 'banner';
    return axios.get(url, { headers: sessionID() }).then(res => {
        return res;
    }).catch(err => {
        userLogs(url, err)
        return err.response
    })
};
